<mat-form-field appearance="outline" class="w-100" [ngClass]="fieldClass" subscriptSizing="dynamic">
  <mat-label>{{ label }}</mat-label>
 
  <mat-select
    [formControl]="itemCtrl"
    multiple
    #multiSelect
    panelClass="multi-select-search-panel"
  >
    <mat-select-trigger>
      {{ (itemCtrl.value || []).length }} selected
    </mat-select-trigger>

    <!-- Search box -->
    <mat-option disabled>
      <ngx-mat-select-search
        [formControl]="itemFilterCtrl"
        [placeholderLabel]="searchPlaceholder"
        [noEntriesFoundLabel]="'No matching items found'"
      ></ngx-mat-select-search>
    </mat-option>
 
    <!-- Select all / Deselect all -->
    <mat-option class="select-all-option" disabled>
      <mat-checkbox
        [checked]="isAllSelected"
        (click)="$event.stopPropagation()"
        (change)="toggleSelectAll($event.checked)"
      >
        {{ isAllSelected ? 'Deselect all' : 'Select all' }}
      </mat-checkbox>
    </mat-option>
 
    <!-- Individual items -->
    <mat-option *ngFor="let item of filteredItems | async" [value]="item.id">
      <mat-checkbox
        [checked]="isItemSelected(item.id)"
        (click)="$event.stopPropagation()"
        (change)="toggleItem(item.id, $event.checked)"
      >
        {{ item.name }}
      </mat-checkbox>
    </mat-option>
  </mat-select>
</mat-form-field>